import { useCallback, useEffect, useState } from 'react';
import INewsArticle from '@myinnsworth/models/news/INewsArticle';
import { useNavigate, useParams } from 'react-router';
import { newsHttpService } from '@myinnsworth/httpServices';
import noNewsPlaceholder from '../../assets/images/no-news-placeholder.png';
import { format } from 'date-fns';
import { useLocation } from 'react-router';

export default function NewsDetails() {
    const params = useParams();
    const nav = useNavigate();
    const location = useLocation();
    const [article, setArticle] = useState<INewsArticle>();

    const scrollToTop = () => {
        const mainElement = document.getElementsByTagName('main')[0];

        if (mainElement) {
            mainElement.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    const onGoBack = () => {
        if (location.pathname.includes('dashboard')) {
            nav('/dashboard/latest-news');
        } else {
            nav(`/cases/${params.slug}/news`);
        }
    };

    const onNextArticle = () => {
        if (location.pathname.includes('dashboard')) {
            nav(`/dashboard/latest-news/${article?.nextArticleId}`);
        } else {
            nav(`/cases/${params.slug}/news/${article?.nextArticleId}`);
        }
    };

    const fetchArticle = useCallback(async () => {
        try {
            const result = await newsHttpService.fetch(parseInt(params.id as string), params.slug);
            setArticle(result);
        } catch {
        }
    }, [params.id, params.slug]);

    useEffect(() => {
        fetchArticle();
    }, [fetchArticle]);

    return (<>
        {article && (
            <div className="news-details-container">
                <div className="flex align-center justify-space-between news-actions">
                    <button onClick={() => onGoBack()}>
                        <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 13L1 7L7 1" stroke="#01065B" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Back to news</button>
                    <button disabled={!article.nextArticleId} onClick={() => onNextArticle()}>
                        Next article
                        <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L7 7L0.999999 13" stroke="#01065B" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>

                <div className="content">
                    <div className="image-container">
                        <img src={article.imageUrl || noNewsPlaceholder} alt="Thumbnail" />
                    </div>
                    <div className="details-container">
                        <label className='title'>Recent news</label>
                        <label htmlFor="">Published: {format(article.publishDate!, 'dd/MM/yyyy hh:mm')}</label>
                        <h6>{article.title}</h6>

                        <div className="text">
                            <span dangerouslySetInnerHTML={{ __html: article.body! }}></span>
                        </div>
                    </div>
                </div>

                <div className="flex justify-center return-button-container">
                    <button className='btn secondary medium' onClick={scrollToTop}>Back to top <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.5 6.7998L6.5 0.799805M6.5 0.799805L12.5 6.7998M6.5 0.799805V15.1998" stroke="#01065B" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    </button>
                </div>
            </div>
        )}
    </>);
}